import React, { useState, useRef, useEffect } from "react";
import { injectGlobal } from "styled-components";

import NavbarLink from "components/App/Navbar/NavbarLink";

injectGlobal`
  #beacon-container .BeaconContainer {
    position: fixed;
    left: 17%; /* beacon config should also be set to 'left' in HS */
  }
`;

function safeCallBeacon() {
  try {
    window.Beacon.apply(window.Beacon, arguments);
  } catch (err) {
    console.error(err);
  }
}

/**
 * Essentially a custom button for opening and closing the HelpScout Beacon
 */
export const GetHelpLink = () => {
  const [beaconIsOpen, setBeaconIsOpen] = useState(false);
  const containerEl = useRef(null);

  const handleOutsideClick = evt => {
    if (containerEl && !containerEl.current.contains(evt.target)) {
      safeCallBeacon("close");
      setBeaconIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  });

  const handleClick = e => {
    e.preventDefault();
    if (beaconIsOpen) {
      safeCallBeacon("close");
      setBeaconIsOpen(false);
    } else {
      safeCallBeacon("open");
      setBeaconIsOpen(true);
    }
  };

  return (
    <div ref={containerEl}>
      <NavbarLink icon="comment" href="#" onClick={handleClick}>
        Get Help
      </NavbarLink>
    </div>
  );
};

export default GetHelpLink;
